export default __webpack_public_path__ + "static/media/portfolio-tablet-side.78d8b839.webp";